module.exports = __webpack_public_path__ + "media/images/amenities_icons/booce_ball-26d34813d5711475d08e13c890d13f2e.svg";